import createReactClass from 'create-react-class';

import {DESIGN} from '../global/libs/CONFIG.js';

let ShareNavbar = createReactClass({
  render: function () {
    return (
      <span>
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              '.sh-panel-header{background-color: ' +
              DESIGN.QA_SHARE_HEADER_BACKGROUND_COLOR +
              '; color: ' +
              DESIGN.QA_SHARE_HEADER_COLOR +
              '; font-size: 24px; text-align: center; position: relative; height: 30px; width: 100%; z-index: 10001; line-height: 30px;}'
          }}
        />
        <div className="sh-panel-header">
          <b>{DESIGN.FRONT_TITLE}</b>
        </div>
      </span>
    );
  }
});

export default ShareNavbar;
